import toast from "react-hot-toast";
import { FormControl, Select, MenuItem, Checkbox, ListItemText, InputLabel, OutlinedInput } from "@mui/material";
import { supabase } from "../../../../../supabase";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useState } from "react";

export default ({ data }) => {
  const colName = "refusal_reason";
  const values = [
    "gel nails / extensions",
    "no face / no talk to cam",
    "no content fit",
    "work with nail-competitor",
    "no female fit",
    "low DACH community",
    "no / low daily stories",
    "no age fit",
    "no / low authenticity score",
    "no german language",
    "low real follower",
  ];

  const [currentValues, setCurrentValues] = useState(data?.[colName] || []);
  const handleChange = async (event) => {
    const value = event?.target?.value;
    setCurrentValues(value);

    // Update database
    try {
      const { error } = await supabase
        .from("influencers")
        .update({ [colName]: value })
        .eq("username", data.username);

      if (error) throw error;

      toast.success("Refusal reason updated");
    } catch (error) {
      console.error("Refusal reason update failed:", error);
      toast.error("Failed to update Refusal reason");
    }
  };

  return (
    <FormControl size="small" variant="outlined">
      <InputLabel id={`${data.id}-refusal-reason-label`} sx={{ marginTop: "-7px" }}>Refusal reason</InputLabel>
      <Select
        labelId={`${data.id}-refusal-reason-label`}
        id={`${data.id}-refusal-reason`}
        input={<OutlinedInput label="Refusal reason" />}
        value={currentValues}
        displayEmpty
        IconComponent={ExpandMoreIcon}
        sx={{
          fontSize: { xs: 10, sm: 11, md: 12 },
          height: { xs: 26, sm: 28, md: 30 },
          borderRadius: 8,
          minWidth: {
            xs: 100,
            sm: 120,
            md: 150,
          },
          maxWidth: {
            xs: 130,
            sm: 160,
            md: 200,
          },
          ".MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            py: { xs: 0.25, md: 0.5 },
          },
          ".MuiOutlinedInput-notchedOutline": {
            border: 0,
          },
        }}
        inputProps={{
          MenuProps: {
            MenuListProps: {
              sx: {
                bgcolor: "#E3E3E3",
              },
            },
          },
        }}
        multiple
        renderValue={(selected) => selected?.join(', ')}
        onChange={handleChange}
      >
        {values.map((value) => (
          <MenuItem key={`${data.id}-${value}`} value={value}>
            <Checkbox checked={currentValues?.includes(value)} />
            <ListItemText primary={value} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
